<script setup>
import { computed, ref, useId } from 'vue';
import InfoIcon from '@/js/core/components/icons/InfoIcon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
});

const isExpanded = ref(false);
const buttonId = useId();
const contentId = useId();

const hasDescription = computed(() => props.description.trim().length > 0);

function toggleDescription() {
  isExpanded.value = !isExpanded.value;
}
</script>

<template>
  <div class="page-heading">
    <div class="page-heading__title-row">
      <h1
        class="page-heading__title"
        :class="{ 'has-info': hasDescription }"
        @click="hasDescription && toggleDescription()"
      >
        {{ title }}
        <button
          v-if="hasDescription"
          :id="buttonId"
          type="button"
          class="page-heading__info-button"
          :aria-expanded="isExpanded"
          :aria-controls="contentId"
          @click.stop="toggleDescription"
        >
          <InfoIcon class="page-heading__info-icon" />
          <span class="visually-hidden">
            {{ isExpanded ? 'Hide page information' : 'Show page information' }}
          </span>
        </button>
      </h1>
      <slot name="actions" />
    </div>
    <div
      v-if="hasDescription"
      :id="contentId"
      class="page-heading__info-content"
      :class="{ 'is-open': isExpanded }"
      role="region"
      :aria-labelledby="buttonId"
    >
      <div class="page-heading__info-inner" v-html="description" />
    </div>
  </div>
</template>
